import { render, staticRenderFns } from "./ycjpxbxq.vue?vue&type=template&id=3278d801"
import script from "./ycjpxbxq.vue?vue&type=script&lang=js"
export * from "./ycjpxbxq.vue?vue&type=script&lang=js"
import style0 from "./ycjpxbxq.vue?vue&type=style&index=0&id=3278d801&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports